import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { ProfileSection } from "@/components/views/account/profile";
import { DangerZone } from "@/components/views/account/danger";
import { ContainerSmall } from "@/components/primitives/container-small";
import {
  LayoutPageDescription,
  LayoutPageH1,
  PageContainer,
} from "@/components/primitives/layout";
import { SecuritySection } from "@/components/views/account/security";
import { GeneralSection } from "@/components/views/account/general";
import { auth } from "@/lib/auth";
import { getRequest } from "@tanstack/react-start/server";

const getAccountData = createServerFn({ method: "GET" }).handler(async () => {
  const request = getRequest();
  const session = await auth.api.getSession({ headers: request.headers });
  if (!session?.user) return null;
  return { name: session.user.name ?? "" };
});

export const Route = createFileRoute("/account")({
  head: () => ({
    meta: [{ title: "Account Settings - Scoopulator" }],
  }),
  beforeLoad: async () => {
    const data = await getAccountData();
    if (!data) {
      throw redirect({ to: "/sign-in" });
    }
    return { accountData: data };
  },
  loader: ({ context }) => context.accountData,
  component: AccountPage,
});

function AccountPage() {
  const { name } = Route.useLoaderData();

  return (
    <PageContainer>
      <ContainerSmall>
        <LayoutPageH1>Account Settings</LayoutPageH1>
        <LayoutPageDescription>
          Manage your account settings and preferences.
        </LayoutPageDescription>
        <div className="mt-8 flex max-w-md flex-col gap-8">
          <GeneralSection />
          <ProfileSection name={name} />
          <SecuritySection />
          <DangerZone />
        </div>
      </ContainerSmall>
    </PageContainer>
  );
}
